import { makeStyles } from 'tss-react/mui';

const useStylesDivider: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  dividerLight: {
    borderColor: `${theme.palette.common.white} !important`,
  },
  dividerOffset: {
    margin: '10px 20px !important',
  },
}));

export default useStylesDivider;
